import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/_services/data.service';
import { Subscription } from 'rxjs';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-manage-auto-it',
  templateUrl: './manage-auto-it.component.html',
  styleUrls: ['./manage-auto-it.component.scss']
})
export class ManageAutoItComponent implements OnInit, OnDestroy {
  default = 'default';
  public searchString: string;
  autoItForm: UntypedFormGroup;
  //subscription: Subscription;
  projectName: any;
  submitted = false;
  title: any;
  projectId: string;
  testData: any;
  projectData: any = {};
  updateForm: boolean = false;
  scriptDataById: any;
  executionMode = ["Sequential", "Parallel"];
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Manage Automation Script',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private project: ProjectService,
    private dataService: DataService,
    private toastrService: ToastrService,
    private router: Router,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    private confirmationDialogService: ConfirmationDialogService) {
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.getTestData();
       // this.getProjectData();
       setTimeout(() => {
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
          }
        ))
      }, 0)
      }
    )
    this.loadForm();

    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
    
  }
  geturlName(url) {
    if (url.includes('/setting/project-setting')) {
      return 'project-setting'
    }
    else if (url.includes('/test/TestSuit')) {
      return 'Test-Case'
    }
    else if (url.includes('/test/TestStep/')) {
      return 'Test-Step'
    }
    else if (url.includes('/data/manage-test-data')) {
      return 'Manage-test-data'
    }
  }
  // getProjectData() {
  //   this.subscription = this.project.getProjectDetails().subscribe((res) => {
  //     this.projectData = res;
  //   })
  // }

  getTestData() {
    this.dataService.getAutoItTestData(this.projectId).subscribe(
      (data) => {
        this.testData = data['autoitscriptData'];
        // TreeData = this.projectdata;
        // this.dataSource = this.projectdata;
      });
  }

  delRow(id) {
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.dataService.deleteAutoItTestData(this.projectId, id).subscribe(
            (data) => {
              this.getTestData();
              this.updateForm = false;
              this.toastrService.clear();
              this.toastrService.success('AutoIt Scripts Deleted Successfully');
              this.ClearForm();
            }
          );
        }
      });
  }

  loadForm() {
    this.autoItForm = this.formBuilder.group({
      name: ['', Validators.required],
      settingName: ['',Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      // runType:[],
      script: []
    })
  }

  get f() { return this.autoItForm.controls; }

  onautoItData() {
    this.submitted = true;
    if (this.autoItForm.invalid) {
      return;
    }
    if (!/^[^:|*?<>/\"]+$/.test(this.autoItForm.value.name)) {
      this.toastrService.clear();
      this.toastrService.error('Automation script name is not valid');
      return;
    }
    var objFormval = this.autoItForm.value;
    if (this.updateForm === true) {
      const ValueForUpdate = {
        id: this.scriptDataById[0].id,
        name: objFormval.name,
        settingName: objFormval.settingName,
        // runType:objFormval.runType,
        script: objFormval.script,
        projectId: this.projectId,
        //  parentTestDataId: this.parentTestDataId
      }

      this.dataService.updateAutoitscriptData(ValueForUpdate).subscribe((data) => {
        if (data) {
          this.testData = data;
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success('AutoIt Scripts Update Successfully')
          this.getTestData();
          this.updateForm = false;
          // this.ClearForm();
        }
      });
    }
    
    if (this.updateForm == false) {
      const ValueForAdd = {
        name: objFormval.name,
        settingName: objFormval.settingName,
        // runType:"SEQUENTIAL",
        script: objFormval.script,
        projectId: this.projectId,
        //  parentTestDataId: this.parentTestDataId
      }

      this.dataService.addAutoitscriptData(ValueForAdd).subscribe((data) => {
        if (data) {
          this.getTestData();
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success('AutoIt Scripts saved Successfully')
        }
      });
    }
  }

  updateScript(id) {
    this.updateForm = true
    let selectedItem = this.testData.filter((f) => f.id === id);
    this.scriptDataById =  JSON.parse(JSON.stringify(selectedItem));
  }

  ClearForm() {
    this.autoItForm.reset();
    this.updateForm = false;
  }

  ngOnDestroy() {
  //  this.subscription.unsubscribe();
  }

}